
IREP.vouchers = (function () {
    var bottomDrawer = null;
    var bottomDrawerLoading = false;

    var init = function (options) {
        $(".dvVoucherDrawerContainer").show(); 
        $("#btnOrderVoucherShowDrawer").click(function () {
            showVoucher(); 
            return false; 
        });
        $(".btnCloseDetails").click(function () {
            closeDrawer ();
            return false;
        });

    };

    var showVoucher = function () {

        if ($("#overlay").length === 0) {
            $("#content").append($("<div id='overlay' />").addClass("overlay"));
        }
        else {
            $("#overlay").show();
        }

        $(".dvVoucherDrawerContainer").show();
        $(".dvVoucherDrawerContainer").animate({ bottom: '0px' }, 500);

        $("#callout2ImgHolder img").height($("#callout1ImgHolder img").height());
        $("#callout2ImgHolder img").width($("#callout1ImgHolder img").width());

        return false;
    };

    var closeDrawer = function () {
        $(".dvVoucherDrawerContainer").animate({ bottom: '-700px' }, 500);
        $("#overlay").hide();
    }

    return {
        init: init
    };
})();